import React from "react";
import { Link } from "react-router-dom";

function PokemonRandom(props) {
  return (
    props.pokemon && (
      <div className="flex justify-center ">
        <Link
          to={`/pokemon/${props.pokemon.id}`}
          className="hover:brightness-125"
        >
          <div>
            <img
              src={props.pokemon.image}
              alt="pokemon random"
              className="max-w-xs w-auto"
            />
          </div>
        </Link>
      </div>
    )
  );
}

export default PokemonRandom;
